(function () {
  let historyStack = []; // Om de navigatiegeschiedenis bij te houden

  document.addEventListener("DOMContentLoaded", function () {
    displayInitialQuestions();
    document.getElementById("backButton").onclick = goBack;
    document.getElementById("mainMenuButton").onclick = displayInitialQuestions;
  });

  const stages = {
    start: {
      text: "Hallo! Ik ben Frits, de chatbot. Waarmee kan ik u van dienst zijn?",
      choices: [
        { next: "Zout", text: "Zout" },
        { next: "Onderhoud", text: "Onderhoud" },
        { next: "Een storing", text: "Storing" },
        { next: "Verkoop", text: "Verkoop" },
        { next: "Handleidingen", text: "Handleiding" },
        { next: "Overig", text: "Overige vragen" },
      ],
    },
    Zout: {
      text: "Ik heb een vraag over zout.",
      subQuestions: {
        "Zout bijvullen":
          "Het zout mag worden aangevuld tot een hoogte van circa 10 centimeter onder de rand.",
        "Wanneer zout bijvullen?":
          "Uw zoutverbruik is volledig afhankelijk van uw waterverbruik. Start met een interval van 4 tot 6 weken voor het bijvullen en pas dit aan indien nodig.",
        "Waar kan ik regeneratie zout kopen?":
          "Wij nemen zout voor u mee tijdens het onderhoud. De monteur heeft altijd voldoende bij zich om voor een jaarvoorraad Topzout bij u achter te laten.",
      },
    },
    Onderhoud: {
      text: "Ik heb een vraag over het onderhoud.",
      subQuestions: {
        "Hoe kan ik onderhoud uit laten voeren":
          "Registreer uw waterontharder op <a href='https://fegon-waterbehandeling.local/garantieformulier/' id='aanmeldLink' target='_blank' rel='noopener'>onze website</a> om deel te nemen aan ons onderhoudsprogramma. Na registratie garanderen wij dat uw waterontahrder continu in optimale conditie blijft. Als u al geregistreerd bent, hoeft u geen verdere stappen te ondernemen.",
        "Hoe vaak is onderhoud nodig":
          "Om uw waterkwaliteit te waarborgen, adviseren wij een onderhoudsfrequentie van circa 12 maanden.",
        "Wat zijn de kosten voor onderhoud":
          "De kosten kunnen verschillen per situatie. Voor een passend antwoord, kunt u contact opnemen met onze afdeling planning via <a href='tel:0788907444'>078 890 74 44</a>, of via planning@fegon.nl.",
      },
    },
    "Een storing": {
      text: "Ik heb een storing.",
      subQuestions: {
        "08 Check Salt": {
          text: "Het lijkt erop dat je problemen hebt met het zoutniveau. Wat is de huidige situatie?",
          subQuestions: {
            "Er zit voldoende zout in":
              "Reset de melding door het apparaat 10 seconden stroomloos te maken. Voeg dan een laag van ongeveer 10 centimeter warm water toe aan de zoutbak, en start een handmatige spoeling. Zorg dat het water in een enkele teug toegevoegd wordt aan de zoutbak. Let op! dat er geen water overstroomt.",
            "Handmatige spoeling":
              "Hoe u een spoeling kunt starten vindt u terug in de handleiding. Heeft u deze niet meer? Dan kunt u de passende handleiding downloaden onder de knop handleidingen, als u op de knop hoofdmenu klikt.",
            "Ik heb al water aan de zoutbak toegevoegd, en een spoeling gestart":
              "Controleer of het proces correct wordt afgerond. U zou nu watergeluid moeten horen, en er zou duidelijk water naar de afvoer moeten lopen. Zo niet, neem dan contact op met onze support op <a href='tel:0788907444'>078 890 74 44</a>, of via service@fegon.nl",
            "De zoutbak was leeg, maar is nu weer gevuld":
              "Reset de melding door het apparaat 10 seconden van de stroom te halen. Verder hoeft u niets te doen.",
          },
        },
        "Hall Error":
          "Reset de melding door het apparaat 10 minuten van de stroom te halen; dit lost doorgaans het probleem op. Als de melding hier niet mee opgelost is, neem dan contact op met de afdeling technisch support op <a href='tel:0788907444'>078 890 74 44</a>, of via <a href:\"mailto:service@fegon.nl\"> service@fegon.nl</a>",
        "Service Tips 0DGNS":
          "Dit is een melding voor het jaarlijkse onderhoud. Als u aangemeld bent nemen wij contact met u op, voor het maken van de afspraak. Klik <a href='https://fegonnl.wp-staging.muntz.online/wp-content/uploads/2024/05/instructies.pdf' id='downloadLink0DGNS' target='_blank' rel='noopener'>hier</a> om de instructies voor het resetten van deze melding te downloaden. Als uw waterontharder nog niet is aangemeld, doe dit dan op <a href='https://fegon-waterbehandeling.local/garantieformulier/' id='aanmeldLink' target='_blank' rel='noopener'>onze website</a>.",
      },
    },
    Verkoop: {
      text: "Ik heb een vraag omtrent verkoop.",
      subQuestions: {
        "Ontharder kopen":
          "Wij bieden geen directe verkoop van waterontharders aan. Echter, we kunnen u voorzien van gerichte informatie op basis van uw specifieke wensen en u in contact brengen met een installateur in uw regio. Selecteer hieronder de gewenste regio voor de installatie en neem contact met ons op.",
        "Zuid-Holland":
          "Maak kennis met Sarah Pastoor. Zij helpt u graag met al uw vragen. Klik <a href='https://fegon-waterbehandeling.local/sarah/'>hier</a> om contact op te nemen met Sarah. <img src='https://fegon-waterbehandeling.local/wp-content/uploads/2024/02/Sarah-Pastoor-Afb.-Website-Fegon-.jpg' alt='sarah' id='sarah' target='_blank' rel='noopener'>",
        "Noord-Holland":
          "Dit is Roel Harink. Met zijn uitgebreide ervaring in het vakgebied staat hij klaar om uw vragen te beantwoorden en u te assisteren. Klik <a href='https://fegon-waterbehandeling.local/roel/'>hier</a> om contact op te nemen met Roel. <img src='https://fegon-waterbehandeling.local/wp-content/uploads/2023/08/Roel-Harink-Afb.-Fegon-Website.jpg' alt='roel' id='roel' target='_blank' rel='noopener'>",
        "Midden-Holland":
          "Dit is Stefan Kempe. Met zijn frisse blik is hij beschikbaar om uw vragen te beantwoorden en u te helpen. Klik <a href='https://fegon-waterbehandeling.local/stefan/'>hier</a> om contact op te nemen met Stefan. <img src='https://fegon-waterbehandeling.local/wp-content/uploads/2024/01/Stefan-Kempe-Afb.-Fegon-website.jpg' alt='stefan' id='stefan' target='_blank' rel='noopener'>",
      },
    },
    Handleidingen: {
      text: "Kies het merk van uw product om de handleiding te downloaden:",
      subQuestions: {
        "Digisoft(er)":
          "<a href='https://fegonnl.wp-staging.muntz.online/wp-content/uploads/2024/05/DigiSoft-DS-500.pdf' id='digisoft1' target='_blank' rel='noopener'>Digisoft DS-500</a><br><a href='https://fegonnl.wp-staging.muntz.online/wp-content/uploads/2024/05/DigiSoft-DS-900-DS-1200-HE-PLUS-DS-2000-HE-PLUS.pdf' id='digisoft2' target='_blank' rel='noopener'>Digisoft DS-900 HE, DS1200 HE Plus, DS-2000 HE Plus</a><br><a href='https://fegonnl.wp-staging.muntz.online/wp-content/uploads/2024/05/Digisofter-DS-500-DS-900.pdf' id='digisofter1' target='_blank' rel='noopener'>Digisofter DS-500 en 900 HE</a><br><a href='https://fegonnl.wp-staging.muntz.online/wp-content/uploads/2024/05/Digisofter-DS-1200-HE-PLUS-DS-2000-HE-Plus.pdf' id='digisofter2' target='_blank' rel='noopener'>Digisofter DS-1200 HE Plus en 2000 HE Plus</a><br><a href='https://fegonnl.wp-staging.muntz.online/wp-content/uploads/2024/05/DigiSoft-DS-2820-HE-5220-HE.pdf' id='digisoft3' target='_blank' rel='noopener'>Digisoft DS-2820 HE en 5220 HE</a><br><a href='https://fegonnl.wp-staging.muntz.online/wp-content/uploads/2024/05/Digisofter-DS-2820-HE-DS-5220-HE.pdf' id='digisofter3' target='_blank' rel='noopener'>Digisofter DS-2820 HE en 5220 HE</a>",
        "Aquastar (Pro)":
          "<a href='https://fegonnl.wp-staging.muntz.online/wp-content/uploads/2024/05/AquaStar-S-500-800-SHE-PLUS-1400-SHE-PLUS-2000-SHE-PLUS.pdf' id='aquastar1' target='_blank' rel='noopener'>Aquastar S-500, 800 SHE Plus, 1400 SHE Plus, 2000 SHE Plus</a><br><a href='https://fegonnl.wp-staging.muntz.online/wp-content/uploads/2024/05/AquaStar-Pro-S-500-ES-1000-HE-PLUS-S-1000-HE-ES-1800-HE-PLUS-S-1800-HE-PLUS.pdf' id='aquastar2' target='_blank' rel='noopener'>Aquastar Pro S-500, ES-1000 HE Plus, S-1000 HE, ES-1800 HE Plus</a><br><a href='https://fegonnl.wp-staging.muntz.online/wp-content/uploads/2024/05/AquaStar-Pro-B-1400D.pdf' id='aquastar3' target='_blank' rel='noopener'>Aquastar Pro B-1400D</a><br><a href='https://fegonnl.wp-staging.muntz.online/wp-content/uploads/2024/05/AquaStar-3010-HE-6010-HE.pdf' id='aquastar4' target='_blank' rel='noopener'>Aquastar 3010 HE en 6010 HE</a><br><a href='https://fegonnl.wp-staging.muntz.online/wp-content/uploads/2024/05/AquaStar-Pro-2600-HE-6800-HE.pdf' id='aquastar5' target='_blank' rel='noopener'>Aquastar Pro 2600 HE en 6800 HE</a>",
        Plieger:
          "<a href='https://fegonnl.wp-staging.muntz.online/wp-content/uploads/2024/05/Handleiding-1014-1030-2024-registreer-via-www.mijnfegon.nl_.pdf' id='plieger1' target='_blank' rel='noopener'>Plieger 1014, Plieger 1030</a>",
        Lavigo:
          "<a href='https://fegonnl.wp-staging.muntz.online/wp-content/uploads/2024/05/Lavigo-WS2000-WS2500.pdf' id='lavigo1' target='_blank' rel='noopener'>Lavigo WS2000 en WS2500</a>",
        Kalkfri:
          "<a href='https://fegonnl.wp-staging.muntz.online/wp-content/uploads/2024/05/Blue-Label-Kalkfri-750-1100-1600.pdf' id='kalkfri1' target='_blank' rel='noopener'>Kalkfri 750, 1100 en 1600</a>",
        Descale:
          "<a href='https://fegonnl.wp-staging.muntz.online/wp-content/uploads/2024/05/Descale-1000-1500.pdf' id='descale1' target='_blank' rel='noopener'>Descale 1000 en 1500</a>",
      },
    },
    Overig: {
      text: "Overige vragen.",
      subQuestions: {
        "Ik heb geen serienummer":
          "Geen nood! U kunt telefonisch een nieuwe aanvragen bij de afdeling technisch support. U krijgt dan een nieuw serienummer, waarmee u de ontharder alsnog kunt aanmelden. Bel daarvoor naar het volgende telefoonnumer: <a href='tel:0788907444'>078 890 74 44</a>. Toets dan 2, om direct in contact te komen met de afdeling Support.",
        Drukverhoger:
          "Soms heb je het te druk, en soms heb je wat druk nodig. Gelukkig kunnen onze waterontharders hier goed tegen. Zorg er wel voor dat de drukverhoger voor de ontharder zit. De waterontharder kan een maximale druk van 7 bar aan.",
      },
    },
  };

  function displayInitialQuestions() {
    console.log("Startvragen weergeven");
    historyStack = []; // Wis de geschiedenis wanneer terug naar het hoofdmenu
    const container = document.getElementById("optionsContainer");
    container.innerHTML = ""; // Wis eerdere inhoud

    const startText = document.createElement("p");
    startText.textContent = stages.start.text;
    container.appendChild(startText);

    stages.start.choices.forEach((choice) => {
      const button = document.createElement("button");
      button.textContent = choice.text;
      button.onclick = function () {
        historyStack.push(displayInitialQuestions); // Sla de huidige staat op in de geschiedenis
        displaySubQuestions(stages[choice.next]);
      };
      container.appendChild(button);
    });

    clearResponse(); // Wis de reactie bij teruggaan naar het hoofdmenu
    updateNavigationButtons(); // Werk de navigatieknoppen bij
  }

  function displaySubQuestions(stage) {
    console.log("Subvragen weergeven voor stage:", stage);
    const container = document.getElementById("optionsContainer");
    container.innerHTML = ""; // Wis eerdere inhoud

    const stageText = document.createElement("p");
    stageText.textContent = stage.text;
    container.appendChild(stageText);

    if (stage.subQuestions) {
      Object.keys(stage.subQuestions).forEach((key) => {
        const button = document.createElement("button");
        button.textContent = key;
        button.onclick = function () {
          historyStack.push(() => displaySubQuestions(stage)); // Sla de huidige staat op in de geschiedenis
          displaySubQuestionsOrResponse(stage.subQuestions[key], key);
        };
        container.appendChild(button);
      });
    }

    clearResponse(); // Wis de reactie bij het wisselen tussen subvragen
    updateNavigationButtons(); // Werk de navigatieknoppen bij
  }

  function displaySubQuestionsOrResponse(content, key = "") {
    console.log("Subvragen of reactie weergeven voor sleutel:", key);
    if (typeof content === "string") {
      showResponse(content, key);
    } else if (content.subQuestions) {
      displaySubQuestions(content);
    }
  }

  function showResponse(response, key) {
    console.log("Reactie weergeven voor sleutel:", key);
    const responseContainer = document.getElementById("responseContainer");
    responseContainer.innerHTML = ""; // Wis eerdere reactie

    const textPara = document.createElement("p");
    textPara.innerHTML = response; // Gebruik innerHTML om HTML-inhoud te ondersteunen
    responseContainer.appendChild(textPara);

    // Controleer of de sleutel overeenkomt met een regio en pas de reactie aan om een link op te nemen
    if (regionLinks[key]) {
      const contactInfo = regionLinks[key];
      const link = document.createElement("a");
      link.href = contactInfo.url;
      link.textContent = contactInfo.name;
      responseContainer.appendChild(link);
    }

    updateNavigationButtons();
  }

  function goBack() {
    console.log("Teruggaan");
    if (historyStack.length > 0) {
      const lastState = historyStack.pop();
      lastState(); // Herstel de laatste staat
    }
    clearResponse(); // Wis de reactie bij teruggaan
    updateNavigationButtons();
  }

  function clearResponse() {
    console.log("Reactie wissen");
    const responseContainer = document.getElementById("responseContainer");
    responseContainer.textContent = ""; // Wis de reactie
  }

  function updateNavigationButtons() {
    console.log("Navigatieknoppen bijwerken");
    const backButton = document.getElementById("backButton");
    backButton.style.display =
      historyStack.length > 0 ? "inline-block" : "none";
  }
})();
